import React, { useEffect } from 'react';
import Capabilities from '../PlatformServices/Capabilities';
import Features from '../Intelligence/Features';
import Process from '../Intelligence/Process';

function Solutions() {
  useEffect(() => {
    const fadeUpElements = document.querySelectorAll('.fade-up');

    const observer = new IntersectionObserver(
      (entries, observerInstance) => {
        entries.forEach((entry) => {
          if (entry.isIntersecting) {
            entry.target.classList.add('visible');
            observerInstance.unobserve(entry.target);
          }
        });
      },
      { threshold: 0.08 },
    );

    fadeUpElements.forEach((element) => observer.observe(element));

    return () => {
      fadeUpElements.forEach((element) => observer.unobserve(element));
    };
  }, []);

  return (
    <>
      <Capabilities />
      <Features />
      <Process />
    </>
  );
}

export default Solutions;
